import React from "react";
import {servicesOffered} from '../constants/constants';

const Services = () => {
    return (
        <div className="what-we-offer" id="services">
            <div className="container container-service p-4">
                <p className="tag">What We Offer</p>
                <h2>Modern, AI-ready solutions that <br/> power your business forward.</h2>
                <p className="tag-services p-3">From stunning web and mobile apps to intelligent automation and
                    cloud-native infrastructure, we help you adopt today's technology to stay ahead of the
                    competition and unlock new possibilities for growth.</p>
                <div className="row pt-4">
                    {servicesOffered.map((service, index) => (
                        <div className="col-md-4">
                            <div className="card-services pb-4">
                                <div className="text-center pt-4 pb-2">
                                    <div className="services-icons">{service.icon}</div>
                                </div>
                                <h2 className="text-center px-3"> {service.title} </h2>
                                <p className="text-center">{service.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
export default Services;
